import { Fragment } from 'react';
import { styled } from 'twin.macro';
import Skeleton from 'react-loading-skeleton';

const MetricsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
`;

const MetricCard = styled.div`
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 20px;
    flex: 1;
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const MetricContent = styled.div`
    display: flex;
    flex-direction: column;
`;

const MetricTitle = styled.div`
    font-size: 1.3rem;
    font-weight: 600;
    color: #5d5b5b;
    text-transform: uppercase;
`;

const MetricValue = styled.div`
    font-size: 2rem;
    font-weight: 700;
    color: black;
    margin-top: 5px;
`;

const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.2rem;
`;

const MetricsSection = ({ metrics = [], loading }) => {
    return (
        <MetricsContainer>
            {metrics.map((metric, index) => {
                return (
                    <MetricCard key={index}>
                        <MetricContent>
                            <MetricTitle>{metric.title}</MetricTitle>
                            <MetricValue>
                                {loading ? <Skeleton /> : <Fragment>{metric.value || <span>&nbsp;-</span>}</Fragment>}
                            </MetricValue>
                        </MetricContent>
                        {metric.component ? (
                            metric.component
                        ) : (
                            <IconContainer style={metric.iconStyles || { backgroundColor: '#000' }}>
                                {metric.icon}
                            </IconContainer>
                        )}
                    </MetricCard>
                );
            })}
        </MetricsContainer>
    );
};

export default MetricsSection;
